// src/components/ContactPage.js
import React from "react";
import ContactForm from "../components/ContactForm";
import contactInfo from "../config/contactInfo";

export default function ContactPage() {
  return (
    <main className="container py-5">
      <div className="row g-4">
        <div className="col-lg-6">
          <h1 className="fw-bold">Contact</h1>
          <p className="text-muted">
            Tell me about your idea — timeline, goals and approximate budget. I’ll reply within 24 hours.
          </p>

          <div className="card shadow-sm mb-3">
            <div className="card-body">
              <h6 className="mb-2">Quick contact</h6>

              <p className="small mb-1">
                <strong>Email:</strong>{" "}
                <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
              </p>

              <p className="small mb-1">
                <strong>Phone:</strong>{" "}
                <a href={`tel:${contactInfo.phone.replace(/\s+/g, "")}`}>
                  {contactInfo.phone}
                </a>{" "}
                (also WhatsApp)
              </p>

              <p className="small mb-0">
                <strong>WhatsApp:</strong>{" "}
                <a
                  href={`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chat on WhatsApp
                </a>
              </p>

              <p className="small text-muted mt-2">
                <strong>Location:</strong> {contactInfo.location}
              </p>
            </div>
          </div>

          <div className="card border-0 bg-light p-3">
            <h6 className="mb-2">Why work with us?</h6>
            <ul className="small text-muted mb-0">
              <li>Fast project kickoff — clear milestones</li>
              <li>Automated tests and CI/CD included</li>
              <li>GDPR & accessibility-minded</li>
            </ul>
          </div>
        </div>

        {/* Keep your ContactForm component as the right column */}
        <div className="col-lg-6">
          <ContactForm />
        </div>
      </div>

      {/* Optional: small FAQ / expectations */}
      <section className="mt-4">
        <div className="row">
          <div className="col-md-6">
            <h6 className="fw-semibold">What happens next?</h6>
            <p className="small text-muted mb-0">
              You’ll get a reply within 24 hours with a short discovery list and a roughly estimated timeline and price. If you agree, we’ll schedule a kickoff call.
            </p>
          </div>
          <div className="col-md-6">
            <h6 className="fw-semibold">Prefer email?</h6>
            <p className="small text-muted mb-0">
              Send us an email at{" "}
              <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a> — include a short description and preferred contact times.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
